export const baseFields = [
  {
    key: 'no',
    label: 'No',
    thClass: 'text-center d-none d-md-table-cell',
    tdClass: 'text-center d-none d-md-table-cell',
    thStyle: { width: '80px' },
    class: 'text-break',
  },
]

export const platformFields = {
  meta: [
    {
      key: 'nama_akun',
      label: 'Nama Akun',
      thClass: 'font-weight-bold',
      tdClass: 'font-weight-medium',
      thStyle: { minWidth: '150px' },
      class: 'text-break',
    },
    {
      key: 'bm_id',
      label: 'ID Bussiness Manager',
      thClass: 'font-weight-bold',
      tdClass: 'd-none d-sm-table-cell',
      thStyle: { minWidth: '120px' },
      class: 'text-break',
    },
    {
      key: 'ad_account_type',
      label: 'Jenis Akun',
      thClass: 'font-weight-bold',
      tdClass: 'd-none d-sm-table-cell',
      thStyle: { minWidth: '120px' },
      class: 'text-break',
    },
  ],
  google: [
    {
      key: 'nama_akun',
      label: 'Nama Akun',
      thClass: 'font-weight-bold',
      tdClass: 'font-weight-medium',
      thStyle: { minWidth: '150px' },
      class: 'text-break',
    },
    {
      key: 'gmail',
      label: 'Gmail',
      thClass: 'd-none d-sm-table-cell',
      tdClass: 'd-none d-sm-table-cell',
      thStyle: { minWidth: '180px' },
      class: 'text-break',
    },
  ],
  tiktok: [
    {
      key: 'nama_akun',
      label: 'Nama Akun',
      thClass: 'font-weight-bold',
      tdClass: 'font-weight-medium',
      thStyle: { minWidth: '150px' },
      class: 'text-break',
    },
    {
      key: 'bc_id',
      label: 'ID TikTok',
      thClass: 'd-none d-sm-table-cell',
      tdClass: 'd-none d-sm-table-cell',
      thStyle: { minWidth: '120px' },
      class: 'text-break',
    },
  ],
}

export const commonFields = [
  {
    key: 'total_spending',
    label: 'Total Spending',
    thClass: 'text-right font-weight-bold',
    tdClass: 'text-right font-weight-bold',
    thStyle: { minWidth: '120px' },
    class: 'text-nowrap',
  },
  {
    key: 'actions',
    label: '',
    thClass: 'text-center font-weight-bold',
    tdClass: 'text-center',
    thStyle: { width: '50px' },
    class: 'position-sticky',
  },
]
